import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CommentForm from '@components/BaseComponents/CommentForm';

import { timelineSelectors, commentsActions, merchantSelectors, toastActions } from '@store/ducks';

const WebsiteCommentForm = ({
  timelineStatuses,
  updateCommentFormData,
  showToast,
  merchantDetails,
}) => {
  const [latestSfComment, setLatestSfComment] = useState(false);
  useEffect(() => {
    const remark = timelineStatuses?.website_status?.error;
    const docRequiredName = merchantDetails?.website_detail?.req_doc_category?.name;
    const docRemark = docRequiredName ? ` Kindly submit the following additional document: ${docRequiredName}` : '';
    setLatestSfComment(remark ? remark + docRemark : false);
  }, [timelineStatuses]);

  return (
    <>
    {
      latestSfComment ? (
        <CommentForm
          remark={latestSfComment}
          onChangeComment={(v) => updateCommentFormData({ websiteComment: v })}
          uploader={{
            handleRemoveFile: () => updateCommentFormData({ websiteCommentUploadedFile: null }),
            onFileDropAccepted: ([file]) => updateCommentFormData({ websiteCommentUploadedFile: file }),
            onFileDropRejected: (fileError) => {
              updateCommentFormData({ websiteCommentUploadedFile: null });
              const err = fileError?.[0]?.errors?.[0]?.message;
              err && showToast({ variant: 'error', title: 'File Upload Failed', content: err });
            },
            maxFileSizeInMB: 5,
            allowedFileExtensions: 'image/png, application/pdf, image/jpg, image/jpeg'
          }}
          className='p-2 mx-4 mb-3'
        />
      ) : <></>
    }
    </>
  )
};

const mapStateToProps = (state) => ({
  timelineStatuses: timelineSelectors.getTimelineStatus(state),
  merchantDetails: merchantSelectors.getMerchantDetails(state),
});

const mapDispatchToProps = (dispatch) => ({
  updateCommentFormData: (formData) => dispatch(commentsActions.updateCommentFormData(formData)),
  showToast: (props) => dispatch(toastActions.show(props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteCommentForm);